import { RunGroup } from "@custom-types/modelRun"
import RunGroupStatusIcon from "@features/run/RunGroupStatusIcon"
import { format } from "date-fns"
import { MRT_ColumnDef } from "material-react-table"
import { graphKeyToVersion } from "utils/graph"
import { readableRunGroupStatus } from "utils/run"

export const getRunGroupTableColumns = (): MRT_ColumnDef<RunGroup>[] => {
  return [
    {
      accessorKey: "run_group_name",
      header: "Name",
    },
    {
      header: "Version",
      accessorFn: (runGroup) => graphKeyToVersion(runGroup.base_graph_key),
      maxSize: 85,
    },
    {
      accessorFn: (runGroup) => (
        <>
          <RunGroupStatusIcon status={runGroup.status} sx={{ mr: 1 }} />
          {readableRunGroupStatus[runGroup.status]}
        </>
      ),
      header: "Status",
      maxSize: 60,
    },
    {
      accessorKey: "description",
      header: "Description",
      grow: 1,
    },
    {
      accessorKey: "creation_date",
      accessorFn: (runGroup) => format(new Date(runGroup.creation_date), "yyyy-MM-dd [HH:mm]"),
      header: "Created",
      maxSize: 100,
    },
    {
      accessorKey: "creator_email",
      header: "Created by",
    },
  ]
}
